
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T2010TeacherBasicService.C40411_doBrowse_AtDataTable', input: {}},
    getStudentList: { api: 'T1010StudentBasicService.getStudentList_Authority', input: {}},
    getSubjectList: { api: 'M1020SubjectService.getAllSubjects', input: {}},
    getAdvisorList: { api: 'T0010UsersService.getAdvisorsDropdown', input: {}},
  },
}

const module = {
  state: {
    PageConst,

    studentList: [],
    subjectList: [],
    advisorList: [],
  },

  getters: {},

  mutations: {},

  actions: {
    async init ({ state }) {
      const res = await $this.$api.postData({
        data: [
          PageConst.ACTION.getStudentList,
          PageConst.ACTION.getSubjectList,
          PageConst.ACTION.getAdvisorList
        ]
      })
      state.studentList = res[0].output
      state.subjectList = res[1].output
      state.advisorList = res[2].output
    },
    async C40411_toggleHiddenRequest ({ state }, payload) {
      await $this.$api.postData({
        data: [
          { api: 'T1035StudentRequestService.C40411_toggleHiddenRequest', input: payload },
        ]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
